import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricIconPlaceholder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 4.33333H13M1 9.66667H13M4 1V13M10 1V13",
		stroke: "#9775FA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMetricIconPlaceholder;
